import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';

export default function VideoInterviewSuccessPage() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-muted flex flex-col items-center justify-center p-6">
            <div className="bg-card rounded-2xl shadow-xl p-8 max-w-md w-full text-center border border-border">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <CheckCircle className="w-10 h-10 text-green-600" />
                </div>

                <h1 className="text-2xl font-bold text-foreground mb-2">Interview Submitted!</h1>
                <p className="text-muted-foreground mb-8 leading-relaxed">
                    Thank you for completing your video interview. Your response has been successfully uploaded and will be reviewed by our team shortly.
                </p>

                <button
                    onClick={() => navigate('/')}
                    className="w-full flex items-center justify-center gap-2 bg-[#1b237a] hover:bg-[#1a2a8f] text-white py-3 px-6 rounded-xl font-semibold transition-all shadow-lg shadow-blue-900/20"
                >
                    <Home className="w-5 h-5" />
                    Return to Home
                </button>
            </div>
        </div>
    );
}
